import React from 'react';

import styles from './Files.module.css';
import {
  CheckOutlined,
  WarningOutlined,
  InsertDriveFileOutlined,
  FileUploadRounded,
  Close,
  Download
} from '@mui/icons-material';
import {CircularProgress} from '@mui/material';
import Button from '@mui/material/Button';
import ActionGroup from '../../../../common/components/ActionGroup';

const maxFilesCount = 10;

const maxFileSize = 10 * 1024 * 1024;

const sizeInMb = (sizeInBytes) => (sizeInBytes / (1024*1024)).toFixed(2);

let id = 0;

const generateId = () => {
  id++;
  return id;
};

export const openDownloadWindow = (file) => {
  const url = window.URL.createObjectURL(file);
  const anchorElement = document.createElement('a');
  anchorElement.href = url;
  anchorElement.download = file.name;
  document.body.appendChild(anchorElement);
  anchorElement.click();
  anchorElement.remove();
};

const statusIconMap = {
  uploaded: <InsertDriveFileOutlined/>,
  signed: <CheckOutlined color="success"/>,
  loading: <CircularProgress size={24} />,
  error: <WarningOutlined color="error"/>
};

export default function Files({files, signType, setFiles, mimeType}) {
  return (
    <div className={styles.files}>
      {Object.entries(files).map(([id, file]) => {
        const nameClasses = [styles.fileName];
        const isXmlFile = file.file.name.endsWith('.xml');
        if (signType === 'readyXML' && !isXmlFile) {
          nameClasses.push(styles.disabledFileName);
        }
        return (
          <div key={id} className={styles.fileContainer}>
            <div className={styles.fileStatus}>
              {statusIconMap[file.status]}
            </div>
            <div className={nameClasses.join(' ')}>{file.file.name}</div>
            <ActionGroup>
              <Button
                disabled={file.status !== 'signed'}
                color="primary"
                variant="contained"
                onClick={() => {
                  openDownloadWindow(file.signedFile);
                }}
              >
                <Download />
              </Button>
              <Button
                color="primary"
                variant="outlined"
                onClick={() => {
                  setFiles(({[id]: deletedFile, ...otherFiles}) => otherFiles);
                }}
              >
                <Close />
              </Button>
            </ActionGroup>
          </div>
        );
      })}
      <div className={styles.uploadContainer}>
        <Button disabled={Object.keys(files).length >= maxFilesCount} variant="contained" color="primary" component="label" startIcon={<FileUploadRounded/>}>
          Загрузить файлы
          <input
            hidden
            multiple
            accept={signType === 'readyXML' ? 'text/xml' : undefined}
            type="file"
            onChange={(e) => {
              const files = [...e.target.files];
              if (files.length > maxFilesCount) {
                alert('Нельзя загрузить более чем 10 файлов');
                return;
              }
              const bigFile = files.find((file) => file.size > maxFileSize);
              if (bigFile) {
                alert(`Нельзя загрузить файл ${bigFile.name}. Его размер превышает допустимые 10 Мб.`);
                return;
              }
              const newFiles = files.reduce((newFiles, file) => {
                newFiles[generateId()] = {file, status: 'uploaded'};
                return newFiles;
              }, {});
              setFiles((prevFiles) => ({
                ...prevFiles,
                ...newFiles,
              }));
              e.target.value = null;
            }}
          />
        </Button>
      </div>
    </div>
  );
}
